import { render, staticRenderFns } from "./IconSvgVector.vue?vue&type=template&id=64a60d46&scoped=true&"
import script from "./IconSvgVector.vue?vue&type=script&lang=js&"
export * from "./IconSvgVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a60d46",
  null
  
)

export default component.exports